import dashboardFR from './dashboard';
import menuAboutFR from './menuAbout';
import labelsFR from './labels';
import releasesFR from './releases';
import artistsFR from './artists';
import artistsWishlistFR from './artistsWishlist';
import profileFR from './profile';
import musicLinksFR from './musicLinks';
import linkLandingPagesFR from './linkLandingPages';
import masteringFR from './mastering';
import featureFR from './feature';
import accountingFR from './accounting';
import paymentMethodsFR from './paymentMethods';
import purchaseHistoryFR from './purchaseHistory';
import trendsFR from './trends';
import earningsDrilldownFR from './earningsDrilldown';
import invoicesFR from './invoices';
import statementsFR from './statements';
import subuserStatementsFR from './subuserStatements';
import userDataFormFR from "./userDataForm";
import creditsFR from './credits';
import disputeClaimsFR from './disputeClaims';
import musicLinkUrlPartsFR from './musicLinkUrlParts';
import subscriptionFR from './subscription';
import twoFactorAuthFR from './twoFactorAuth';
import generalFR from './general';
import routerFR from './router';
import escrowWalletFR from './escrowWallet';
import subUsersFR from './subUsers';
import tokensFR from './tokens';
import tracksFR from './tracks';
import acrAlertFR from './acrAlert';
import qcNoteFR from './qcNote';
import flaggedContentFR from "./flaggedContent";
import deliveryConfirmationFR from './deliveryConfirmation';
import preScanFR from './preScan';
import accessKeysFR from './accessKeys';
import announcementsFR from './announcements';

const translationFR = {
    'router': routerFR,
    'general': generalFR,
    'dashboard': dashboardFR,
    'menuAbout': menuAboutFR,
    'labels': labelsFR,
    'artists': artistsFR,
    'artistsWishlist': artistsWishlistFR,
    'releases': releasesFR,
    'tracks': tracksFR,
    'profile': profileFR,
    'musicLinks': musicLinksFR,
    'musicLinkUrlParts': musicLinkUrlPartsFR,
    'linkLandingPages': linkLandingPagesFR,
    'mastering': masteringFR,
    'feature': featureFR,
    'accounting': accountingFR,
    'paymentMethods': paymentMethodsFR,
    'purchaseHistory': purchaseHistoryFR,
    'trends': trendsFR,
    'earningsDrilldown': earningsDrilldownFR,
    'invoices': invoicesFR,
    'statements': statementsFR,
    'subuserStatements': subuserStatementsFR,
    'credits': creditsFR,
    'userDataForm': userDataFormFR,
    'disputeClaims': disputeClaimsFR,
    'subscription': subscriptionFR,
    'twoFactorAuth': twoFactorAuthFR,
    'escrowWallet': escrowWalletFR,
    'subUsers': subUsersFR,
    'tokens': tokensFR,
    'acrAlert': acrAlertFR,
    'qcNote': qcNoteFR,
    'flaggedContent': flaggedContentFR,
    'deliveryConfirmation': deliveryConfirmationFR,
    'preScan': preScanFR,
    'accessKeys': accessKeysFR,
    'announcements': announcementsFR,
};

export default translationFR;
